// Auth
export const LOGIN = '/api/auth/login';
export const LOGOUT = '/api/auth/logout';
export const REGENERATE_TOKEN = '/api/auth/regenerateToken';
export const USER_REG = '/api/auth/register';
export const FETCH_USER = '/api/list-user';
export const DELETE_USER = '/api/detete-user';
export const UPDATE_USER = '/api/update-user';
export const IMPORT_USERS = '/api/users/import';

export const ALLROLES = '/api/auth/all-get-roles';

export const RESETPASSWORD = '/api/auth/reset-password';
export const FORGOT_PASSWORD = '/api/auth/forgot-password';
export const CHANGE_PASSWORD = '/api/change-password';

export const FETCH_UF_DIMENSIONAL_OBS = '/api/uf-dimensionobs';
export const ADD_UF_DIMENSIONAL_OBS = '/api/uf-dimensional-obs-params';
export const FETCH_UF_VISUAL_OBS = '/api/show-fitment-visualobs';
export const FETCH_UF_COMPONENT_NAMES = '/api/get-component-name';
export const ADD_UF_COMPONENT_NAMES = '/api/component-name';
// export const FETCH_UF_TYPE = "/api/uf-frame-types";
export const FETCH_UF_MACHINE_NAMES = '/api/get-machine-name';
export const ADD_UF_CROSS_MEMBER_OBS = '/api/insert-uf-cross-member-params';
export const FETCH_UF_STAGES = '/api/get-uf-stages';
export const FETCH_UF_VISUAL_TYPES = '/api/get-uf-stage-visual-types';

// Visual type
export const ADD_VISUAL_TYPES = '/api/insert-stage-visual-types';
export const UPDATE_VISUAL_TYPES = '/api/update-visual-type';
export const DELETE_VISUAL_TYPES = '/api/visual-type';

export const FETCH_METAL_TYPES = '/api/get-metal-types';
export const ADD_UF_VISUAL_OBS = '/api/uf-fitment-visualobs';
export const ADD_UF_MACHINE_NAMES = '/api/machine-name';
export const FETCH_OPERATION_NAMES = '/api/get-operation-name';
export const ADD_OPERATION_NAME = '/api/operation-name';
export const FETCH_UF_FRAME_TYPES = '/api/uf-frame-types';
export const FETCH_ALL_UF_FRAME_TYPES = '/api/all-uf-frame-types';
export const ADD_UF_FRAME_TYPE = '/api/frametype-name';
export const FETCH_DRG_NUMBERS = '/api/get-drgNo';
export const FETCH_ROOF_DRG_NUMBERS = '/api/get-roof-drgNo';
export const ADD_DRG_NUMBER = '/api/insert-drgNo';
export const FETCH_INSTRUMENTS = '/api/instruments';
export const ADD_SHEET_METAL = '/api/sheet-metal-component';
export const FETCH_SHEET_METAL = '/api/get-sheet-metal-component';
export const ADD_INSTRUMENTS = '/api/instrument-name';
export const FETCH_UF_MAKES = '/api/get-all-makes';
//frametype Api
//Roof
export const FETCH_ROOF_DIMENSIONAL_OBS = '/api/get-roof-dimensional-obs';
export const ADD_ROOF_DIMENSIONAL_OBS = '/api/insert-roof-dimensional-obs';
export const DELETE_ROOF_DIMENSIONAL_OBS = '/api/delete-roof-dimensional-obs';
export const GET_ROOF_DIMENSIONAL_OBS_BY_ID = '/api/get-roof-dimensional-obs';
export const UPDATE_ROOF_DIMENSIONAL_OBS = '/api/update-roof-dimensional-obs';
export const ADD_MASTER_OPERATION_NAME = '/api/master-operation-name';
export const FETCH_MASTER_OPERATION_NAMES = '/api/master-operation-data';

export const ADD_BUFFER_CBC_OBS = '/api/insert-buffer-cbc-obs';
export const UPDATE_BUFFER_CBC_OBS = '/api/update-buffer-cbc-obs';
export const FETCH_BUFFER_CBC_OBS = '/api/get-buffer-cbc-obs';
export const GET_BUFFER_CBC_OBS_BY_ID = '/api/get-buffer-cbc-obs';

export const FETCH_TRAIN_TYPES = '/api/get-train-type';
export const FETCH_UF_CROSS_MEMBER = '/api/uf-cross-member-params';
export const ADD_TRAIN_TYPE = '/api/insert-train-type';
export const DELETE_TRAIN_TYPE = '/api/train-type';
// export const UPDATE_DIMENSIONAL_OBS = '/api/update-uf-dimensional-obs';
export const DELETE_DRG_NUMBERE = '/api/delete-drgNo';
export const DELETE_UF_FRAME_TYPE = '/api/delete-uf-frame-types';
export const DELETE_OPERATION_NAME = '/api/delete-operation-name';
export const DELETE_MASTER_OPERATION_NAME = '/api/delete-master-operation-name';
export const DELETE_INTRUMENT_NAME = '/api/delete-instrument-name';
export const DELETE_COMPONENT_NAME = '/api/delete-component-name';
export const DELETE_CENTRALINE_NAME = '/api/delete-centaline-name';
export const UPDATE_DIMENSIONAL_OBS = '/api/update-uf-dimensional-obs';
export const FETCH_SHIFT_TYPES = '/api/get-shift-types';
export const GET_UF_STAGE_ONE = '/api/get-uf-stage-one-params';

//Role & Permission endpoints
export const ROLES = '/api/roles';
export const ROLESTORE = '/api/roles-store';

export const ROLE_PERMISSIONS = '/api/roles-permissions';
export const PERMISSIONS = '/api/permissions';
export const ROLESDELETE = '/api/roles-delete';
export const MODULE_ADD = '/api/modules';
export const FETCH_MASTER_DRGNOS_ALL_BIND = '/api/fetch-master-drgnos-all';

export const GET_UF_STAGE_TWO = '/api/get-uf-stage-two-params';
export const FETCH_MASTER_DRGNOS = '/api/get-master-drgnos';
export const DELETE_METAL_SHEET_DATA = '/api/sheet-metal-component';
export const UPDATE_METAL_SHEET_DATA = '/api/update-sheet-metal-component';

export const GET_ROOF_STAGE_ONE = '/api/get-roof-stage-one-params';
export const GET_ROOF_STAGE_TWO = '/api/get-roof-stage-two-params';
export const GET_END_WALL_STAGE_ONE = '/api/get-endwall-stage-one-params';
export const GET_END_WALL_STAGE_TWO = '/api/get-endwall-stage-two-params';

export const ADD_UF_STAGE_ONE_DATA = '/api/stage1-uf-quality-check';

export const ADD_UF_STAGE_TWO_DATA = '/api/stage2-uf-quality-check';

export const FETCH_SIDE_WALL_STAGE_ONE_FORM = '/api/get-sidewall-stage-one-params';

export const GET_UF_STAGE_ONE_DATA = '/api/get-uf-stage-one-data';
export const GET_VIEW_UF_STAGE_ONE_DATA = '/api/get-view-uf-stage-one-data';
export const GET_VIEW_UF_STAGE_TWO_DATA = '/api/get-view-uf-stage-two-data';

// Roof CRUD
export const ADD_ROOF_STAGE_ONE = '/api/store-roof-stage-one-data';
export const GET_ROOF_LIST = '/api/fetch-roof-stage-one-list';
export const GET_ROOF_TWO_LIST = '/api/fetch-roof-stage-two-list';
export const DELETE_ROOF_DATA = '/api/delete-stage-one';
export const DELETE_ROOF_STAGE_TWO = '/api/delete-roof-stage-two';
export const GET_EW_STAGE_ONE_DATA = '/api/get-ew-stage-one-data';
export const GET_ROOF_NUMBERS_FOR_STAGE_TWO = '/api/get-roof-numbers-for-stage-two';
export const GET_UF_STAGE_TWO_DATA = '/api/uf-stage-two-list';

export const DELETE_SIDE_WALL_STAGE_ONE = '/api/delete-side-wall-quality-check';
export const ADD_SIDE_WALL_QUALITY_CHECK = '/api/insert-side-wall-stage-one-quality-check';
export const FETCH_SIDE_WALL_STAGE_ONE_LIST = '/api/get-side-wall-quality-check';
export const UPDATE_SIDE_WALL_STAGE_ONE_DATA = '/api/update';
export const FETCH_SIDE_WALL_STAGE_TWO_FORM = '/api/get-sidewall-stage-two-params';
export const DELETE_SIDE_WALL_STAGE_TWO = '/api/delete-side-wall-stage-two-quality-check';
export const FETCH_METAL_FRAME_NUMBER = '/api/get-uf-frame-number';
export const FETCH_METAL_UF_NUMBER = '/api/get-uf-frame-number';
export const FETCH_SIDE_WALL_STAGE_TWO_LIST = '/api/get-side-wall-quality-check-stagetwo-list';
export const ADD_SIDE_WALL_STAGE_TWO = '/api/insert-side-wall-quality-check-stagetwo';
export const GET_SIDE_WALL_FRAME_NUMBERS = '/api/get-sw-frame-number';
export const GET_SIDE_WALL_DRAWING_NUMBERS = '/api/get-sw-drgNo';
export const FETCH_METAL_FRAME_NUMBER_SIDEWALL = '/api/get-sw-frame-number';
export const UPDATE_ALL_ONE_ACTION = '/api/take-action-forward-flow';
export const DATA_GET_SIDE_WALLFLOW_HISTORY = '/api/side-wall/flow-history';
export const UPDATE_ALL_ONE_ACTION_LATEST = '/api/take-action-forward-flow_latest';
//end wall
export const ADD_END_WALL_STAGE_ONE = '/api/store-endwall-stage-one-data';
export const ADD_END_WALL_STAGE_TWO = '/api/store-endwall-stage-two-data';
export const LIST_END_WALL_STAGE_TWO = '/api/get-ew-stage-two-data';
export const STORE_VISUAL_OBS_DATA = '/api/uf-visual-update';
export const GET_EW_FRAME_NUMBER = '/api/get-ew-frame-number';
export const DATA_GET_END_WALLFLOW_HISTORY = '/api/end-wall/flow-history';

//roof stage-2
export const ADD_ROOF_STAGE_TWO = '/api/store-roof-stage-two-data';
//stage 3 roof

export const GET_ROOF_STAGE_THREE = '/api/get-roof-stage-three-params';
export const ADD_ROOF_STAGE_THREE = '/api/store-roof-stage-three-data';
export const GET_ROOF_THREE_LIST = '/api/fetch-roof-stage-three-list';
export const DELETE_ROOF_STAGE_THREE = '/api/delete-stage-three';
export const UPDATE_ROOF_STAGE_FLOW = '/api/roof-update-flow-status';
export const ROOF_FLOW_HISTORY = '/api/roof-flow-history';
export const GET_ROOF_NUMBERS = '/api/master-roof-nos';
export const CHECK_DUPLICATE = '/api/check-duplicate';

export const FETCH_SIDE_WALL_STAGE_THREE_FORM = '/api/get-sidewall-stage-three-params';
export const ADD_SIDE_WALL_STAGE_THREE = '/api/side-wall-stage-three-quality-check';

export const FETCH_SIDE_WALL_STAGE_THREE_LIST = '/api/get-stage-three-quality-check';

export const DELETE_SIDE_WALL_STAGE_THREE = '/api/delete-stage-three-quality-check';

//FETCH DRWAING NUMBER
export const FETCH_DRAWING_NUMBERS = '/api/get-uf-drgNo';
//assembly
export const FETCH_ASSEMBLY_STAGE_ONE_FORM = '/api/get-stage1-assembly-params';
export const FETCH_ASSEMBLY_STAGE_ONE_LIST = '/api/get-list-stage1-assembly';
export const ADD_ASSEMBLY_STAGE_ONE_LIST = '/api/insert-stage1-assembly';
export const ADD_ASSEMBLY_STAGE_THREE_LIST = '/api/insert-stage3-assembly';
export const FETCH_ASSEMBLY_STAGE_THREE_FORM_LIST = '/api/get-stage3-assembly-params';
export const GET_ASSEMBLY_STAGE_THREE_LIST = '/api/get-list-stage3-assembly';
export const DATA_GET_ASSEMBLY_STAGE_THREE_HISTORY = '/api/assebly-stage-three-flow-history';

//uf flow
export const UPDATE_UF_FLOW_STATUS = '/api/uf-update-flow';
// Final inspection
export const FETCH_FINAL_INSPECTION_FORM = '/api/get-final-inspection-params';
export const FETCH_FINAL_INSPECTION_LIST = '/api/get-final-inspection-list';
export const ADD_FINAL_INSPECTION_LIST = '/api/insert-final-inspection-data';
export const FETCH_FINAL_INSPECTION_BY_ID = '/api/final-inspection/get-by-id';
//end flow
export const UPDATE_EW_FLOW_STATUS = '/api/ew-update-flow';
export const FINAL_INSPECTION_DELETE = '/api/delete-final-inspection';
//dashboard
export const FETCH_DASHBOARD_COUNTS = '/api/dashboard/counts';
export const MAIN_DASHBOARD = '/api/dashboard';
export const SHELL_DASHBOARD = '/api/shell-dashboard';

//fetch end wall drawing number
export const GET_EW_DRAWING_NUMBER = '/api/get-ew-drgNo';
export const PRINT_METAL_SHEET = '/api/metalsheet-print-download';
export const GET_SHELL_NUMBER = '/api/get-shell-numbers';

//view for ew stage one
export const GET_VIEW_EW_STAGE_ONE_DATA = '/api/get-view-ew-stage-one-data';
// view ew stage two
export const GET_VIEW_EW_STAGE_TWO_DATA = '/api/get-view-ew-stage-two-data';

//------------------------ view roof-----------------------------------
export const GET_VIEW_ROOF_STAGE_ONE_DATA = '/api/get-view-roof-stage-one-data';
export const GET_VIEW_ROOF_STAGE_TWO_DATA = '/api/get-view-roof-stage-two-data';
export const GET_VIEW_ROOF_STAGE_THREE_DATA = '/api/get-view-roof-stage-three-data';
// UnderFrame flow
export const UPDATE_UF_FLOW = '/api/uf-update-flow-status';
export const GET_UF_FLOW_HISTORY = '/api/uf-flow-history';

//------------------------------------ view side wall ------------------------------

export const GET_VIEW_SIDE_WALL_STAGE_ONE_DATA = '/api/get-view-side-wall-stage-one-data';
export const GET_VIEW_SIDE_WALL_STAGE_TWO_DATA = '/api/get-view-side-wall-stage-two-data';
export const GET_VIEW_SIDE_WALL_STAGE_THREE_DATA = '/api/get-view-side-wall-stage-three-data';

//rites sup user
export const FETCH_RITES_SUP_USER = '/api/rites-sup-user';

//view final inspection
export const VIEW_FINAL_INSPECTION_FORM = '/api/get-view-final-inspection-data';
export const FINAL_INSPECTION_FLOW_HISTORY = '/api/get-viewHistory';

//get under frame number
export const GET_UF_FRAME_NO = '/api/get-uf-frame-number';
export const GET_ALL_NUMBER_BY_MODULE = '/api/numbers/all';

//Paint
export const ADD_PAINT_DATA = '/api/paint-insert';
export const GET_PAINT = '/api/paint-list';
export const GET_UF_FRAME_NOS = '/api/get-uf-nos';
export const FETCH_MASTER_UF_NUMBERS = '/api/get-master-uf-nos';

export const UPDATE_PAINT_STATUS = '/api/paint/update-stage';
export const GET_PAINT_HISTORY = '/api/paint/history';
export const DELETE_PAINT = '/api/paint/delete';
export const PAINT_HISTORY = '/api/paint-get-history';
export const PAINT_REPORT = '/api/paint-report';

//daily turnout
export const DAILY_TURNOUT_STORE = '/api/insert-daily-turnout';
export const GET_DAILY_TURNOUT = '/api/get-daily-turnout';
export const FETCH_MASTER_EW_NUMBERS = '/api/get-master-ew-nos';

//view paint
export const GET_VIEW_PAINT = '/api/paint-get-record';

//Daily Report
export const ADD_FRONT_PART = '/api/insert-front-part';
export const ADD_LAV_SIDE_WALL = '/api/insert-lav-side-wall';
export const GET_FRONT_PART = '/api/get-front-part';
export const GET_LAV_SIDE_WALL = '/api/get-lav-side-wall';
export const ADD_SHOWER_TESTING = '/api/insert-shower-testing';
export const FETCH_SHOWER_TESTING = '/api/get-shower-testing';
export const DAILY_SHELL_REPORT = '/api/shell-reports';
export const DAILY_SHELL_REPORT_LIST = '/api/shell-report-list';

export const MONTHLY_SHELL_REPORT = '/api/shell-monthly-report';

// Boggie-----------------------------------
export const GET_BLOSTER_STAGE_INS_PARAMS = '/api/get-bolster-stage-insp-params';
export const GET_BLOSTER_FINAL_STAGE_INS_PARAMS = '/api/get-bolster-final-stage-insp-params';
export const GET_BLOSTER_FRAMEL_COMPL_INS_PARAMS = '/api/get-bolster-frame-compl-insp-params';
export const GET_BREAK_BEAM_LH_PARAMS = '/api/get-break-beam-lh-params';
export const GET_SIDE_FRAME_LH_PARAMS = '/api/get-side-frame-lh-params';

export const ADD_BOLSTER_STAGE_INSPECTION = '/api/insert-bolster-stage-inspection';
export const LIST_BOLSTER_STAGE_INSPECTION = '/api/list-bolster-stage-inspection';

export const ADD_BOLSTER_FINAL_SI = '/api/insert-bolster-final-si';
export const LIST_BOLSTER_FINAL_SI = '/api/list-bolster-final-si';

export const ADD_BOGIE_FRAME_COMPLETE = '/api/insert-bogie-frame-complete';
export const LIST_BOGIE_FRAME_COMPLETE = '/api/list-bogie-frame-complete';

export const ADD_BREAK_BEAM_INSPECTION = '/api/insert-break-beam-inspection';
export const LIST_BREAK_BEAM_INSPECTION = '/api/list-break-beam-inspection';
export const ADD_SIDE_FRAME_SI = '/api/insert-side-frame-si';
export const LIST_SIDE_FRAME_SI = '/api/list-side-frame-si';

// boggie assembly
export const STAGE_INSP_LINE_ASSEMBLY = '/api/get-bogie-line-assembly-params';
export const GET_BOGGIE_FORM = '/api/get-bogie-form5008B-params';
export const VIEW_BOLSTER_STAGE_INSPECTION = '/api/view-bolster-stage-inspection';

export const FETCH_SPRING_TYPES = '/api/spring-types';
export const FETCH_MASTER_BOSTER_NO = '/api/get-master-boster-no';
export const FETCH_BOGIE_DRAWING_NO = '/api/get-bogie-drgNo';
export const FETCH_CAPACITY = '/api/get-capacity';

export const FETCH_MASTER_BOGIE_FRAME_NO = '/api/get-master-bogie-frame-no';
export const FETCH_MASTER_BOGIE_FRAME_TYPE = '/api/get-master-bogie-frame-type';
export const FETCH_MASTER_SIDE_FRAME_NO = '/api/get-master-side-frame-no';
export const FETCH_MASTER_BREAK_BEAM_NO = '/api/get-master-break-beam-no';
export const FETCH_MASTER_BOGIE_NO = '/api/get-master-bogie-no';

export const VIEW_BOLSTER_FINAL_SI = '/api/view-bolster-final-si';

export const VIEW_BREAK_BEAM_INSPECTION = '/api/view-break-beam';
export const VIEW_SIDE_FRAME_INSPECTION = '/api/view-side-frame';
export const VIEW_BOGIE_FRAME_INSPECTION = '/api/view-bogie-frame';

export const DEPARTMENTS = '/api/departments';

export const UPDATE_PAINT_FLOW = '/api/paint-update-flow-status';
export const GET_PAINT_FLOW_HISTORY = '/api/paint-flow-history';
export const ADD_CLEARANCE = '/api/insert-clearance';
export const LIST_CLEARANCE = '/api/list-clearance';

//wheel
export const ADD_WHEEL_STAGE_ONE = '/api/store-wheel-stage-one';
export const ADD_WHEEL_STAGE_FOUR = '/api/store-wheel-stage-four';
export const GET_WHEEL_STAGE_ONE_LIST = '/api/wheel-stage-one-list';
export const REJECT_STAGE_ONE = '/api/wheel/stage-one/reject';
export const GET_WHEEL_STAGE_FOUR_LIST = '/api/wheel-stage-four-list';
export const UPDATE_WHEEL_FLOW = '/api/wheel/stage-one/update-flow-status';
export const WHEEL_FLOW_HISTORY = '/api/wheel/stage-one/history';
export const GET_WHEEL_STAGE_FOUR_REJECT_FORWARD = '/api/update-wheel-stage-four-status';
export const REJECT_STAGE_THREE = '/api/wheel/stage-three/reject';
export const REJECT_STAGE_SIX = '/api/wheel/stage-six/reject';
export const REJECT_STAGE_FOUR = '/api/wheel/stage-four/reject';

//stage 3 and 6
export const ADD_WHEEL_STAGE_THREE = '/api/store-wheel-stage-three';
export const GET_WHEEL_STAGE_THREE_LIST = '/api/wheel-stage-three-list';
export const UPDATE_WHEEL_STAGE_THREE = '/api/wheel-stage-three/update';
export const VIEW_WHEEL_STAGE_THREE = '/api/wheel-stage-three/view';

export const ADD_WHEEL_STAGE_SIX = '/api/store-wheel-stage-six';
export const GET_WHEEL_STAGE_SIX_LIST = '/api/wheel-stage-six-list';
export const UPDATE_WHEEL_STAGE_SIX = '/api/wheel-stage-six/update';
export const VIEW_WHEEL_STAGE_SIX = '/api/wheel-stage-six/view';

export const DELETE_WHEEL_STAGE_ONE = '/api/wheel-stage-one/delete';
export const VIEW_WHEEL_STAGE_ONE = '/api/wheel-stage-one/view';
//stage two wheel
export const ADD_WHEEL_STAGE_TWO = '/api/store-wheel-stage-two';

export const UPDATE_BOGIE_FLOW = '/api/bogie-update-flow-status';
export const GET_BOGIE_FLOW_HISTORY = '/api/bogie-flow-history';

export const ADD_ASSEMBLY_STAGE_INP_LINE = '/api/assembly/stage-insp-line-assembly';
export const LIST_ASSEMBLY_STAGE_INP_LINE = '/api/get-assembly/stage-insp-line-assembly-listing';
export const FETCH_BOGIE_ASSEMBLY_INS_BY_ID = '/api/get-assembly-stage-by-id';
export const VIEW_BOGIE_ASSEMBLY_INSPECTION_FORM = '/api/view-assembly-bogie';
export const BOGIE_ASSEMBLY_FLOW_HISTROY = '/api/bogie-assembly/flow-history';
export const BOGIE_ASSEMBLY_COMPLETED_STAGE = '/api/assembly/get-completeStage';
export const ADD_ASSEMBLY_STAGE_STATIC_LOAD_DATA = '/api/assembly/stage-static-load-assembly';
export const LIST_ASSEMBLY_STAGE_STATIC_LOAD_DATA = '/api/assembly/stage-static-load-list';
export const VIEW_ASSEMBLY_STAGE_STATIC_LOAD_DATA = '/api/assembly/stage-static-load-view';
export const FETCH_BOGIE_STATIC_LOAD_ASSEMBLY_INS_BY_ID =
  '/api/assembly/stage-static-load-edit-by-id';
export const BOGIE_ASSEMBLY_STATIC_FLOW_HISTROY = '/api/bogie-assembly-static/flow-history';
export const BOGIE_ASSEMBLY_STAGE_INSPECTION_DELETE = '/api/boggie-assembly/delete';
export const BOGIE_ASSEMBLY_STATIC_LOAD_DELETE = '/api/boggie-assembly-static-load/delete';

//---------------------electrical--------------------------------------

export const S3_ROOF_PRECELLING_PARAMS = '/api/s3-roof-precelling-params';
export const FINAL_QC_PARAMS = '/api/final-qc-insp-params';
export const RMPU_CHECKSHEET_PARAMS = '/api/rmpu-checksheet-params';

export const ROOF_PRECELLING_STORE = '/api/store-roof-precelling-data';
export const ROOF_PRECELLING_LIST = '/api/list-roof-precelling-data';
export const ROOF_PRECELLING_UPDATE_FLOW_STATUS = '/api/roof-precelling/update-flow-status';
export const ROOF_PRECELLING_HISTORY = '/api/roof-precelling-history';
export const ROOF_PRECELLING_VIEW = '/api/roof-precelling-view';
//wheel stage two II
export const ADD_WHEEL_STAGE_TWO_BRAKE_DISC = '/api/wheel-stage-two-brake-disc';
export const GET_WHEEL_STAGE_TWO_BRAKE_DISC_LIST = '/api/wheel-stage-two-brake-disc-list';
export const VIEW_WHEEL_STAGE_TWO_BRAKE_DISC = '/api/wheel-stage-two-brake-disc-view';
export const REJECT_WHEEL_STAGE_TWO_BRAKE_DISC = '/api/wheel-stage-two-brake-disc-reject';
export const FIRE_SAFETY_PARAMS = '/api/fetch-fire-safety-params';
export const FINAL_QUALITY_INSPECTION_LIST = '/api/get-final-quality-inspection-ele-list';
export const CREATE_ELE_FINAL_QUALITY_INSPECTION = '/api/add-final-quality-inspection';
export const GET_ELECTRICAL_INSPECTION_DATA = '/api/get-ele-final-quality-inspection';
export const CHANGE_FLOW_STATUS_ELECTRICAL_FINAL_INSPECTION =
  '/api/change_flow_status-ele-final_quality_inspection';
export const GET_ELECTRICAL_HISTORY = '/api/get-electrical-history';
export const GET_SELECTED_ELECTRICAL_HISTORY = '/api/get-selected-electrical-history';
// electrical fire safety
export const CREATE_UPDATE_ELECTRICAL_FIRE_SAFETY = '/api/electrical-fire-safety/create-update';
export const ELECTRICAL_FIRE_SAFETY_LIST = '/api/electrical-fire-safety/list';
export const ELECTRICAL_FIRE_SAFETY_GET_HISTORY = '/api/electrical-fire-safety/get-history/';
export const ELECTRICAL_FIRE_SAFETY_FLOW_STATUS_CHANGE =
  '/api/change-flow-status/electrical-fire-safety';
export const S3_ROOF_PRECELLING_FLOW_HISTORY = '/api/get-s3-electrical-flow-history/';
//----------------------furnishing--------------------------------------

export const FETCH_FLOOR_PVC_PARAMS = '/api/fetch-floor-pvc-params';
export const FETCH_PARTITION_PARAMS = '/api/get-partition-params';
export const FETCH_PANELLING_PARAMS = '/api/get-panelling-params';
export const FETCH_SEAT_BERTH_PARAMS = '/api/get-seat-berth-params';
export const FETCH_LAVATORY_PARAMS = '/api/get-lavatory-params';
export const FETCH_PLUMBING_PARAMS = '/api/get-plumbing-params';
export const FETCH_AIR_BRAKE_PARAMS = '/api/get-air-brake-params';
export const FETCH_WINDOW_CEILING_PARAMS = '/api/get-window-ceiling-params';
export const FETCH_MOULDING_DOOR_PARAMS = '/api/fetch-module-door-params';
export const FETCH_FURNISHING_QCI_PARAMS = '/api/get-furnishing-qci-params';
export const FETCH_FURNISHING_TESTING_FIRE_PARAMS = '/api/get-furnishing-testing-fire-params';
export const FETCH_FURNISHING_TESTING_BIOTOILET_PARAMS =
  '/api/get-furnishing-testing-biotoilet-params';
export const FETCH_BUFFER_CBC_PARAMS = '/api/get-buffer-cbc-params';
export const FETCH_TESTING_LEAKAGE_PARAMS = '/api/get-furnishing-testing-leakage-params';

export const FETCH_MASTER_COACH_NO = '/api/get-master-coach-no';

export const STORE_WINDOW_CEILING = '/api/window-ceiling/store';
export const FETCH_WINDOW_CEILING_LIST = '/api/window-ceiling/list';
export const VIEW_WINDOW_CEILING = '/api/window-ceiling/view';
export const DELETE_WINDOW_CEILING = '/api/window-ceiling/delete';
export const CHECK_WINDOW_CEILING_DUPLICATE = '/api/window-ceiling/check-duplicate';
export const GET_LUGGAGE_RACK_PARAMS = '/api/get-luggage-rack-params';

//store furnising floor and pvc
export const ADD_FLOOR_PVC = '/api/store/floor-pvc';
export const LIST_FLOOR_PVC = '/api/list/floor-pvc';
export const VIEW_FLOOR_PVC = '/api/view/floor-pvc';

//partition
export const ADD_PARTITION = '/api/store/partition';
export const LIST_PARTITION = '/api/list/partition';
export const VIEW_PARTITION = '/api/view/partition';
export const PARTITION_FLOW_HISTORY = '/api/partition/flow-history';

//panneling
export const ADD_PANNELING = '/api/store/panneling';
export const LIST_PANNELING = '/api/list/panneling';
export const VIEW_PANNELING = '/api/view/panneling';
export const PANNELING_FLOW_HISTORY = '/api/panneling/flow-history/';

//get shell no
export const GET_FURNISHING_SHELL_NO = '/api/get/furnishing-shell-no';

export const SAVE_MOULDING_DOOR = '/api/save-moulding-door';
export const LIST_MOULDING_DOOR = '/api/list-moulding-door';
export const VIEW_MOULDING_DOOR = '/api/view-moulding-door';
export const FURNISING_MODULINGDOOR_FLOW_HISTROY = '/api/furnishing-stageaudit/flow-history';

export const SAVE_PLUMBING = '/api/save-plumbing';
export const LIST_PLUMBING = '/api/list-plumbing';
export const VIEW_PLUMBING = '/api/view-plumbing';
export const FURNISING_PUMBLING_FLOW_HISTROY = '/api/furnishing-stageaudit-plumbing/flow-history';

export const SAVE_AIR_BRAKE = '/api/save-air-brake';
export const LIST_AIR_BRAKE = '/api/list-air-brake';
export const VIEW_AIR_BRAKE = '/api/view-air-brake';
export const FURNISING_AIR_BRAKE_FLOW_HISTROY = '/api/furnishing-stageaudit-airbrake/flow-history';
// Seat & Berth
export const STORE_SEAT_BERTH = '/api/furnishing/seat-berth/store';
export const FETCH_SEAT_BERTH_LIST = '/api/furnishing/seat-berth/list';
export const VIEW_SEAT_BERTH = '/api/furnishing/seat-berth/view';
export const CHECK_SEAT_BERTH_DUPLICATE = '/api/furnishing/seat-berth/check-duplicate';

// Lavatory
export const STORE_LAVATORY = '/api/furnishing/lavatory/store';
export const FETCH_LAVATORY_LIST = '/api/furnishing/lavatory/list';
export const VIEW_LAVATORY = '/api/furnishing/lavatory/view';
export const CHECK_LAVATORY_DUPLICATE = '/api/furnishing/lavatory/check-duplicate';

export const FETCH_AIR_BRAKE_POINTS = '/api/fetch-air-brake-points';

// Common Furnishing Routes
export const UPDATE_FURNISHING_STATUS = '/api/furnishing/update-status';
export const GET_FURNISHING_FLOW_HISTORY = '/api/furnishing/flow-history';
export const CHECK_FURNISHING_DUPLICATE = '/api/furnishing/check-duplicate';
export const FETCH_TESTING_AIR_BRAKE_PARAMS = '/api/fetch-testing-air-brake-params';
export const AIR_DELIVERY_DATA_PARAMS = '/api/fetch-air-delivery-data-params';
export const TESTING_FIBA_PARAMS = '/api/get-testing-fiba-params';

export const GET_FURNISHING_HISTORY_FLOW = '/api/furnishing/floor-flow-history';
export const UPDATE_FURNISHING_FLOW = '/api/furnishing/update-flow';
//fire detection
export const STORE_FIRE_DETECTION = '/api/store-fire-detection';
export const LIST_FIRE_DETECTION = '/api/list-fire-detection';
export const VIEW_FIRE_DETECTION = '/api/view-fire-detection';
export const FETCH_TESTING_BUFFER_CBC_OBS_PARAMS = '/api/get-furnishing-testing-buffer-cbc-params';

export const STORE_BIOTOILET = '/api/store-biotoilet';
export const LIST_BIOTOILET = '/api/list-biotoilet';
export const VIEW_BIOTOILET = '/api/view-biotoilet';

// /leakage
export const STORE_LEAKAGE = '/api/store-leakage';
export const LIST_LEAKAGE = '/api/list-leakage';
export const VIEW_LEAKAGE = '/api/view-leakage';

export const LIST_TESTING_FIBA = '/api/list-testing-fiba-params';
export const VIEW_TESTING_FIBA = '/api/view-testing-fiba-params';
export const STORE_TESTING_FIBA = '/api/store-testing-fiba-params';
export const FIBA_TESTING_FLOW_HISTORY = '/api/get-fiba-testing-flow-history';
export const UPDATE_FIBA_TESTING_STATUS = '/api/update-fiba-testing-status';
export const GET_MASTER_COACH_NO = '/api/get-elctrical-master-coach-no';
export const GET_MASTER_SHELL_NO = '/api/get-master-shell-no';

export const STORE_FUNISHING_QCI_DATA = '/api/save-furnishing-qci';
export const LIST_FURNISHING_QCI = '/api/list-furnishing-qci';
export const VIEW_FURNISHING_QCI_ASSEMBLY = '/api/view-furnishing-qci-assembly';
export const VIEW_FURNISHING_QCI_STAGE = '/api/view-furnishing-qci-stage';
export const FURNISHING_QCI_FLOW_HISTORY = '/api/furnishing-qci/flow-history';
export const DELETE_FURNISHING_QCI = '/api/furnishing-qci';
export const FURNISHING_QCI_COMPLETED_STAGES = '/api/furnishing-qci/completed-stages';
export const FURNISHING_QCI_FETCHED_LATSET_STAGES = '/api/furnishing-qci/last-stage-data';

//fetch fire flow history
export const FIRE_FLOW_HISTORY = '/api/fire-flow-history';
export const LEAKAGE_FLOW_HISTORY = '/api/leakage-flow-history';
export const BIOTOILET_FLOW_HISTORY = '/api/biotoilet-flow-history';

export const UPDATE_FIRE_FLOW_STATUS = '/api/update-fire-flow-status';
export const UPDATE_LEAKAGE_FLOW_STATUS = '/api/update-leakage-flow-status';
export const UPDATE_BIOTOILET_FLOW_STATUS = '/api/update-biotoilet-flow-status';

//testing Air breake
export const TESTING_AIR_BRAKE_LIST = '/api/testing-air-brake/list';
export const TESTING_AIR_BRAKE_VIEW = '/api/testing-air-brake/view';
export const TESTING_AIR_BRAKE_STORE = '/api/testing-air-brake/store';
export const TESTING_AIR_BRAKE_UPDATE_STATUS = '/api/testing-air-brake/update-status';
export const TESTING_AIR_BRAKE_HISTORY = '/api/testing-air-brake/history';

export const STORE_ELECTRICAL_RMPU_DATA = '/api/electrical/rmpu-checksheet/store';
export const LIST_ELECTRICAL_RMPU_DATA = '/api/electrical/rmpu-checksheetlist-data';

export const TESTING_BUFFER_CBC_LIST = '/api/buffer-cbc/list';
export const TESTING_BUFFER_CBC_VIEW = '/api/buffer-cbc/view';
export const TESTING_BUFFER_CBC_STORE = '/api/buffer-cbc/store';
export const TESTING_BUFFER_CBC_UPDATE_STATUS = '/api/buffer-cbc/update-status';
export const TESTING_BUFFER_CBC_HISTORY = '/api/buffer-cbc/history';
export const FETCH_BUFFER_CBC_OBS_PARAMS = '/api/fetch-testing-buffer-cbc-params';
export const CHECK_RECORD_EXIST = '/api/furnishing-stage-check';

export const CHECK_PVC_TYPE_EXIST = '/api/furnishing/exists-floor-pvc-stages';
export const VIEW_FLOOR_PVC_ASSEMBLY = '/api/view-floor-pvc-assembly';
export const VIEW_FLOOR_PVC_STAGE = '/api/edit-floor-pvc-stage';
export const FLOOR_PVC_FLOW_HISTORY = '/api/floor-pvc/flow-history';
export const TAKE_ACTION_FLOOR_PVC = '/api/take-action-floor-pvc';

export const TAKE_ACTION_WINDOW_CEILING = '/api/take-action-window-ceiling';

export const VIEW_WINDOW_CEILING_STAGE = '/api/view-window-ceiling-stage';
export const WINDOW_CEILING_FLOW_HISTORY = '/api/window-ceiling-nonac-flow-history';

export const LIST_ELECTRICAL_RMPU_DATA_BY_ID = '/api/electrical/rmpu-checksheet/get-by-id';
export const DELETE_ELECTRICAL_RMPU_DATA = '/api/electrical/rmpu-checksheet/delete';
export const STORE_ELECTRICAL_RMPU_DATA_INSPECTIONDATA = '/api/electrical/rmpu-checksheet/action';
export const VIEW_ELECTRICAL_RMPU_DATA = '/api/electrical/rmpu-checksheet/view';
export const RMPU_ASSEMBLY_FLOW_HISTORY = '/api/rmpu-checksheet/flow-history';

export const DELETE_STAGE_AUDIT_DELETE = '/api/stage-audit/delete';
export const DELETE_ELECTRICAL_DATA = '/api/electrical-data/delete';

export const DELETE_SHEET_METAL_DATA = '/api/metal-sheet-data/delete';
export const DELETE_UNDER_FRAME_DATA = '/api/under-frame-data/delete';
export const DELETE_ROOF_DATA_DETAILS = '/api/roof-data/delete';
export const DELETE_END_WALL_DATA = '/api/end-wall-data/delete';
export const DELETE_ASSEMBLY_DATA = '/api/assembly-data/delete';

export const DELETE_PAINT_INSPECTION_DATA = '/api/paint-inspection/delete';

export const DELETE_BOGIE_FABRICATION_DATA = '/api/bogie-fabrication/delete';

export const DELETE_WHEEL_STAGE_DATA = '/api/wheel-stage/delete';
export const FETCH_ROOM_TYPES = '/api/fetch-room-types';

export const UPDATE_SHELL_ASSEMBLY_STATUS = '/api/shell-assembly/update-status';
export const UPDATE_SHELL_ASSEMBLY_STAGE_THREE_STATUS =
  '/api/shell-assembly/stage-three/update-status';

export const FETCH_PAINT_INSULATION_DATA = '/api/get-thermal-insulation-params';

//thermal solution
export const ADD_THERMAL_INSULATION = '/api/store-thermal-insulation';
export const LIST_THERMAL_INSULATION = '/api/list-thermal-insulation';
export const VIEW_THERMAL_INSULATION = '/api/view-thermal-insulation';
export const UPDATE_THERMAL_FLOW_STATUS = '/api/update-thermal-flow-status';
export const HISTORY_THERMAL_INSULATION = '/api/history-thermal-insulation';

//paintshop dashboard
//export const GET_PAINT_DASHBOARD = '/api/paint/dashboard';

//cr position report
export const ADD_CR_POSITION = '/api/store-cr-position';
export const LIST_CR_POSITION = '/api/list-cr-position';

export const FINAL_INSPECTION_COMPLETED_STAGE = '/api/final-inspection/completed-stages';
export const FETCH_LAST_FRAME_QCI_DATA = '/api/fetch-last-shell-qci';
//Daily Dispatch Report

export const STORE_DAILY_DISPATCH_REPORT_LIST = '/api/store-daily-dispatch-reports-list';
export const STORE_DAILY_DISPATCH_REPORT = '/api/store-daily-dispatch-reports';
//backlog
export const ADD_BACKLOG = '/api/store-backlog';
export const LIST_BACKLOG = '/api/list-backlog';

//wheel dashboard
export const WHEEL_DASHBOARD = '/api/wheel-dashboard';
//boggie dashboard
export const BOGGIE_DASHBOARD = '/api/boggie-dashboard';
//paintshop dashboard
export const PAINT_DASHBOARD = '/api/paint-dashboard';
export const FURNISHING_DASHBOARD = '/api/furnishing/dashboard';

// In apiConstant.js
export const ELECTRICAL_DASHBOARD = '/api/electrical-dashboard';
export const FURNISHING_MODULE_DASHBOARD = '/api/furnishing/dashboard';

export const STORE_WHEEL_DAILY_REPORT = '/api/wheel-daily-report';
export const FETCH_WHEEL_DAILY_REPORT = '/api/fetch-wheel-daily-report';
export const GET_BOGIE_STAGE_NUMBERS = '/api/get-bogie-all-no';
// Bogie report
export const STORE_DEFECT_MANAGEMENT = '/api/store-defect-management';

// Bogie defect get
export const GET_BOGIE_STATIC_LOAD_DEFECT_REPORT = '/api/static-load-defect-test';
export const GET_LIST_DEFECT_MANAGEMENT = '/api/list-defect-management';

// ic Doors
export const GET_IC_DOOR_FORM_PARAMS = '/api/get-icdoor-params';
export const IC_DOORS_LIST = '/api/ic-doors-list';
export const IC_DOORS_STORE = '/api/ic-doors-store';
export const IC_DOORS_FLOW_HISTORY = '/api/get-icdoor-flow-history';
export const INSPECTION_REPORT_DATA = '/api/get-plugdoor-params';
export const IC_DOORS_VIEW_DATA = '/api/get-icdoor-view-data';
export const IC_UPDATE_FLOW_STATUS = '/api/update-icdoor-flow-status';
// export const INSPECTION_REPORT_DATA = '/api/get-plugdoor-params';

export const GET_SHELL_NUMBERS = '/api/get-shell-numbers';
export const GET_COACH_NUMBERS = '/api/get-coach-numbers';
export const GET_PLUGDOOR_PARAMS = '/api/get-plugdoor-params';

//Floor Board
export const VIEW_FLOORBOARD = '/api/view/floorboard';

export const GET_DCOUPLING_PARAMS = '/api/get-dcoupling-params';
export const STORE_DCOUPLING_PARAMS = '/api/coupling-store';
export const DCOUPLING_LIST = '/api/coupling-listing';
export const DCOUPLING_VIEW = '/api/coupling-view';
export const LIST_FLOORBOARD = '/api/list/floorboard';
export const FETCH_FLOORBOARD_PARAMS = '/api/get-floorboard-params';

// store floor board
export const STORE_FLOORBOARD = '/api/store/floorboard';
export const UPDATE_STATUS_FLOORBOARD = '/api/floor-board/update-flow';
export const FETCH_SAF_FLOOR_PVC_PARAMS = '/api/get-saffloorpvc-params';
export const ADD_SAF_FLOORPVC = '/api/store/vb-floorpvc';
export const VIEW_SAF_FLOORPVC = '/api/view/vb-floorpvc';
export const LIST_SAF_FLOORPVC = '/api/list/vb-floorpvc';
export const HISTORY_FLOORBOARD = '/api/floor-board/history';
export const UPDATE_VB_FLOORPVC_STATUS = '/api/floor-pvc/vb-update-flow';
export const HISTORY_VB_FLOORPVC = '/api/floor-pvc/vb-history';
export const DELETE_VB_FLOORPVC = '/api/delete-vb-floor-pvc';
export const DELETE_FLOORBOARD = '/api/delete-floor-board';

// Gangway

export const FETCH_GANGWAY_PARAMS = '/api/get-gangway-params';
export const FETCH_GLASSWOOL_PARAMS = '/api/get-glasswool-params';
export const FETCH_SAFWINDOW_PARAMS = '/api/get-safwindow-params';
export const FETCH_SAFPARTITION_PARAMS = '/api/get-safpartition-params';
export const FURNISING_GANGWAY_FLOW_HISTROY = '/api/gangway-flow';
export const FURNISING_DCOUPLING_FLOW_HISTROY = '/api/dcoupling-flow';
export const STORE_GANGWAY_PARAMS = '/api/gangway-store';
export const FETCH_GANGWAY_LIST = '/api/gangway-listing';
export const GANGWAY_VIEW = '/api/gangway-showData';
export const GET_ACDUCT_PARAMS = '/api/get-ac-duct-params';
export const STORE_ACDUCT_PARAMS = '/api/store-ac-duct-data';

// plug dooor
export const STORE_UPDATE_PLUGDOOR = '/api/store-plug-door';
export const LISTING_PLUGDOOR = '/api/list-plug-door';
export const PLUGDOOR_DELETE = '/api/delete-plug-door';
export const PLUGDOOR_FLOW_HISTORY = '/api/get-plugdoor-flow-history';
export const PLUGDOOR_UPDATE_FLOW_STATUS = '/api/update-plugdoor-flow-status';
//glass wool
export const STORE_GLASS_WOOL = '/api/store/glass-wool';
export const LIST_GLASS_WOOL = '/api/list/glass-wool';
export const VIEW_GLASS_WOOL = '/api/view/glass-wool';
export const UPDATE_GLASS_WOOL_STATUS = '/api/glass-wool/update-flow';
export const GET_SEAT_PARAMS = '/api/get-safseat-params';

export const DELETE_GLASS_WOOL = '/api/delete-glass-wool';
export const FETCH_GLASS_WOOL_HISTORY = '/api/glass-wool/history';

export const FETCH_VB_AIRBRAKE_PARAMS = '/api/get-vb-air-brake-params';

//Ac Duct
export const STORE_AC_DUCT = '/api/store/ac-duct';
export const LIST_AC_DUCT = '/api/list/ac-duct';
export const VIEW_AC_DUCT = '/api/view/ac-duct';
export const UPDATE_AC_DUCT_STATUS = '/api/ac-duct/update-flow';
export const DELETE_AC_DUCT = '/api/delete-ac-duct';
export const FETCH_AC_DUCT_HISTORY = '/api/ac-duct/history';

// window
export const FURNISING_WINDOW_FLOW_HISTROY = '/api/window-flow';
export const STORE_WINDOW_PARAMS = '/api/window-store';
export const FETCH_WINDOW_LIST = '/api/window-listing';
export const WINDOW_VIEW = '/api/window-showData';

export const FETCH_PANELLING_VB_PARAMS = '/api/get-safpanelling-params';
export const FETCH_LAVATORY_VB_PARAMS = '/api/get-saflavatory-params';
export const FETCH_PRECEILING_REPORT_DATA = '/api/fetch-preceiling-report-data';
export const FETCH_INSPECTED_SHELL_TYPES = '/api/fetch-inspected-shell-type';
export const FETCH_FINAL_REPORT_DATA = '/api/fetch-final-report-data';

// Luggage Rack
export const STORE_LUGGAGE_RACK = '/api/luggage-rack-store-update'; // update and store luggage rack data
export const LIST_LUGGAGE_RACK = '/api/luggage-rack-listing';
export const LUGGAGE_RACK_DELETE = '/api/luggage-rack-delete/';
export const GET_LUGGAGE_RACK_FLOW_HISTORY = '/api/luggage-rack-get-flow-history/';
export const UPDATE_LUGGAGE_RACK_FLOW_STATUS = '/api/luggage-rack-update-flow-status/';

// VB Panel
export const FURNISING_VB_PANEL_FLOW_HISTROY = '/api/panel-flow';
export const STORE_VB_PANELLING_PARAMS = '/api/panel-store';
export const FETCH_VB_PANEL_LIST = '/api/panel-listing';
export const VB_PANEL_VIEW = '/api/panel-showData';
// VB Lavatory
export const FURNISING_VB_LAVATORY_FLOW_HISTROY = '/api/vb-lavatory-flow';
export const STORE_VB_LAVATORY_PARAMS = '/api/vb-lavatory-store';
export const FETCH_VB_LAVATORY_LIST = '/api/vb-lavatory-listing';
export const VB_LAVATORY_VIEW = '/api/vb-lavatory-showData';

// Partition for VB
export const STORE_PARTITION_PARAMS = '/api/partitionvb-store';
export const FETCH_PARTITION_LIST = '/api/partitionvb-listing';
export const PARTITION_VIEW = '/api/partitionvb-showData';
export const FURNISHING_PARTITION_FLOW_HISTORY = '/api/partitionvb-flow';

// seat inspection
export const STORE_SEAT_INSPECTION_VB = '/api/seatinspectionvb-store';
export const FETCH_SEAT_INSPECTION_VB_LIST = '/api/seatinspectionvb-listing';
export const VIEW_SEAT_INSPECTION_VB = '/api/seatinspectionvb-showData';
export const SEAT_INSPECTION_VB_FLOW_HISTORY = '/api/seatinspectionvb-flow';

// testing vb bio toilet
export const STORE_UPDATE_VB_BIOTOILET = '/api/biotoilet-store';
export const FETCH_VB_BIOTOILET_LIST = '/api/biotoilet-listing';
export const DELETE_VB_BIOTOILET = '/api/biotoilet-delete/';
export const UPDATE_VB_BIOTOILET_FLOW_STATUS = '/api/biotoilet-update-flow_status';
export const GET_VB_BIOTOILET_FLOW_HISTORY = '/api/get-biotoilet-flow-history/';
export const VIEW_VB_BIOTOILET_FLOW_HISTORY = '/api/biotoilet-view_flow_history/';

export const CR_POSITION_DETAILS_LIST = '/api/cr-position-detail';
export const STORE_CR_POSITION = '/api/cr-position-report';
export const QFR_PRECELLING_STORE = '/api/store-qfd-preceiling-data';
export const QFR_FINAL_QUALITY_STORE = '/api/store-qfd-final-data';

// Air Brake Test for VB
export const STORE_AIRBRAKE_TEST_VB = '/api/airbraketestvb-store';
export const FETCH_AIRBRAKE_TEST_VB_LIST = '/api/airbraketestvb-listing';
export const VIEW_AIRBRAKE_TEST_VB = '/api/airbraketestvb-showData';
export const AIRBRAKE_TEST_VB_FLOW_HISTORY = '/api/airbraketestvb-flow';
export const GET_TRACTION_PARAMS = '/api/get-traction-params';

// Traction
export const STORE_TRACTION_MOTOR_VB = '/api/tractionmotorvb-store';
export const FETCH_TRACTION_MOTOR_VB_LIST = '/api/tractionmotorvb-listing';
export const VIEW_TRACTION_MOTOR_VB = '/api/tractionmotorvb-showData';
export const TRACTION_MOTOR_VB_FLOW_HISTORY = '/api/tractionmotorvb-flow';
export const DELETE_TRACTION_DATA = '/api/traction-motor-vb-delete';
// Wheel Shop QC Report
export const WHEEL_SHOP_QC_REPORT = '/api/fetch-wheel-daily-report';
export const CHECK_ELECTRICAL_RECORD_EXIST = '/api/check-record-exist';
//Air Delivery
export const CREATE_AIR_DELIVERY = '/api/create-airdelivery-coach-reading';
export const FETCH_AIR_DELIVERY_LIST = '/api/airdelivery-coach-reading-list';
export const UPDATE_AIR_DELIVERY_FLOW_STATUS = '/api/update-airdelivery-flow-status';
export const DELETE_AIR_DELIVERY = '/api/airdelivery-coach-reading-delete';

export const CHECK_FURNISHING_RECORD_EXIST = '/api/check-furnishing-record-exist';

export const GET_BRAKE_EQUIPMENT_SUPPLIERS = '/api/get/brake_equipment_suppliers';
export const GET_INSTALLED_BY = '/api/get/installed_by';

export const ADD_SHELL_VITAL_POINTS = '/api/add-daily-shell-vital-points';
export const FETCH_SHELL_VITAL_POINT_DAILY = '/api/fetch-shell-vital-point-daily';

export const MONTHLY_INSPECTION_REPORT_LIST = 'api/report/monthly-inspection-report-list';
export const SHOP_LIST = '/api/shops';

export const DELETE_QFR_PRECELLING_DATA = '/api/delete-preceiling-report-data';
export const DELETE_QFR_FINAL_QUALITY_DATA = '/api/delete-final-report-data';
export const SHOP_FORM_DATA_LIST = '/api/shops-form';

export const CHECK_DUP_UNDER_FRAME = '/api/check-under-frame-existing-record'
export const GET_CAPTCHA_CODE = '/api/auth/generate-captch-code'

export const VERSION_LIST = '/api/version-list'
export const GET_VISUAL_OBS_HISTORY = '/api/get-fitment-visualflow-history/'
export const GET_DISTINCT_SHELL_NOS = '/api/fetch-distinct-shell-nos/'
export const NOTIFICATION_GET = '/api/notifications'
export const NOTIFICATION_GET_SINGLE = '/api/notifications';